<template lang="pug">
form
  .d-flex(v-if="!success")
    input.text-field(
      type="text" 
      v-model="email" 
      placeholder="Your email..." 
      :class="{ 'is-invalid': emailError }" 
    )
    .bw-button.push-button( @click.prevent="postForm") Join the waitlist
  div(v-else) You are on the waitlist :)
  div.error-message(v-if="emailError") {{ emailError }}
</template>

<script>
export default {
  data: function() {
    return {
      email: "",
      success: false,
      emailError: null // To store email validation error
    };
  },
  methods: {
    // Email validation method
    validateEmail(email) {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Basic email regex pattern
      return emailPattern.test(email);
    },
    postForm() {
      // Check if email is valid
      if (!this.validateEmail(this.email)) {
        this.emailError = "Please enter a valid email address.";
        return;
      }

      this.emailError = null; // Clear any previous error

      // Create the new request
      var xhr = new XMLHttpRequest();
      var url =
        "https://api.hsforms.com/submissions/v3/integration/submit/7711542/584946c2-5d19-48e6-ae35-c651b2e01df4";

      var date = new Date();
      var timestamp = date.getTime();

      var data = {
        submittedAt: timestamp,
        fields: [
          {
            name: "email",
            value: this.email
          }
        ],
        context: {
          hutk: "893352c5ff370bbe924a738f9c4ed581", // Optional cookie tracking
          pageUri: "budg.ee",
          pageName: "Home page"
        }
      };

      var final_data = JSON.stringify(data);

      xhr.open("POST", url);
      xhr.setRequestHeader("Content-Type", "application/json");

      xhr.onreadystatechange = () => {
        if (xhr.readyState == 4 && xhr.status == 200) {
          this.success = true;
        } else if (xhr.readyState == 4 && xhr.status == 400) {
          alert(xhr.responseText);
        } else if (xhr.readyState == 4 && xhr.status == 403) {
          alert(xhr.responseText);
        } else if (xhr.readyState == 4 && xhr.status == 404) {
          alert(xhr.responseText);
        }
      };

      // Sends the request
      xhr.send(final_data);
    }
  }
};
</script>

<style lang="stylus" scoped>
@import "./../../assets/styles/mixins.styl";

.d-flex
  display: flex;
.text-field
  border-radius: 4px;
  padding: 4px 8px;
  border: 1px solid #ccc;
  min-width: 240px;
.is-invalid
  border-color: red;
.error-message
  color: #ffffff;
  margin-top: 6px;
  position: absolute;
  box-shadow: 2px 2px 3px 2px rgba(0, 0, 0, 0.1);
  padding: 3px;
  background: #000000b8;
  border-radius: 5px;
</style>
